import localforage from "localforage";
import { toast } from "@/apis/request";
import { authLogout } from "@/apis/logoutAPI";
import { setToken } from "@/apis/getToken";
import { setPermissions } from "@/apis/getPermisions";
import { setCurrentCompanyId } from "@/apis/getCurrentCompanyId";
import { setUserInfo } from "@/apis/getUserInfo";
import { getPlatformDomain } from "./utils";

export const errorHandling = (
  error,
  shouldRedirect = true,
  showNotyForWrongData = true
) => {
  // if (!error) {
  //   return toast.error("Unknown Error");
  // }
  // Network Error
  if (!error || error.isRetry) {
    return;
  }
  // compat for jQuery ajax error handler
  if (error.responseJSON && !error.response) {
    error.response = {
      data: error.responseJSON,
      status: error.status
    };
  }
  if (error.response) {
    let errorObject = error.response.data;
    if (errorObject) {
      // if (typeof errorObject === "object" && !errorObject.message) {
      //   errorObject.message = "Already logout on other page";
      // }
      let status = error.response.status;
      let httpCodes = [400, 401, 403, 422, 502, 504, 404, 500, 503];
      if (status === 499) {
        toast.alert(errorObject.message, {
          afterClose: () => {
            authLogout();
          }
        });
      } else if (
        (status === httpCodes[2] || status === httpCodes[3]) &&
        showNotyForWrongData
      ) {
        const errors = errorObject?.errors || errorObject?.message?.errors;
        if (errors) {
          if (typeof errors === "string") {
            toast.error(errors);
          } else {
            for (let objs in errors) {
              errors[objs].forEach(errMsg => {
                toast.error(errMsg);
              });
            }
          }
        }
      } else if (status === httpCodes[1]) {
        if (shouldRedirect === true) {
          setToken(null);
          setPermissions([]);
          setUserInfo({});
          setCurrentCompanyId(null);
          // localforage.clear().then(() => {
          //   window.location.replace("/login");
          // });
          authLogout();
        } else {
          toast.error(errorObject.message, {
            afterClose: () => {
              window.location.replace(getPlatformDomain());
            }
          });
        }
      } else if (status === httpCodes[7]) {
        toast.error(errorObject.message || "Internal Server Error");
      }
      // else if (status === httpCodes[4]) {
      //   toast.error(errorObject.message || "Bad Gateway");
      // } else if (status === httpCodes[5]) {
      //   toast.error(errorObject.message || "Gateway Timeout");
      // } else if (status === httpCodes[6]) {
      //   toast.error(errorObject.message || "404 Not Found");
      // } else if (status === httpCodes[7]) {
      //   toast.error(errorObject.message || "Internal Server Error");
      // } else if (status === httpCodes[8]) {
      //   toast.error(errorObject.message || "Service Unavailable");
      // } else {
      //   toast.error(errorObject.message);
      // }
    }
    // else {
    //   toast.error(errorObject.message);
    // }
  } else if (error.message) {
    toast.error(error.message);
  }
};
